module.exports = __webpack_public_path__ + "static/img/liveBg02.5a66184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/liveBg02.png
// module id = Dz9P
// module chunks = 101